import React from 'react';
const steps = [{
  title: 'La visite',
  text: "On se voit sur place, je regarde les supports et j'écoute ce que vous voulez obtenir."
}, {
  title: 'Le devis',
  text: 'Un chiffrage clair, poste par poste, sans surprise en cours de chantier.'
}, {
  title: 'Le chantier',
  text: 'Protection des sols et du mobilier, préparation soignée, puis les finitions.'
}, {
  title: 'La remise',
  text: 'On fait le tour ensemble. Je ne pars que si le rendu vous convient.'
}];
export function Methode() {
  return <section id="methode" className="w-full scroll-mt-24 bg-ink py-20 text-sand-50 md:py-28" data-id="element-85" data-mp="11u23g6lbw715">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-14 px-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-86" data-mp="wwjtccvkrlrk">
        <div data-id="element-87" data-mp="ssvm5vauus6u">
          <h2 className="font-display text-4xl leading-tight sm:text-5xl" data-id="element-88" data-mp="nvlyak346ol4">La méthode</h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-sand-300" data-id="element-89" data-mp="nxgana0bl8dl">
            Passion Rénovation, c'est Tony Rumor. Pas de sous-traitance surprise : la personne qui
            vous fait le devis est celle qui tient le pinceau.
          </p>
        </div>

        <ol className="relative border-l border-white/15 pl-8" data-id="element-90" data-mp="1tdcsfg0blwuh">
          {steps.map((step, index) => <li key={step.title} className={index === steps.length - 1 ? '' : 'pb-10'} data-id="element-91" data-mp="1fm7zsxvde4tn" data-mpi={index}>
              <span aria-hidden="true" className="absolute -left-[9px] mt-1.5 flex h-[18px] w-[18px] items-center justify-center rounded-full border border-brique bg-ink" data-id="element-92" data-mp="1kjzqjoka3kw9">
                <span className="h-1.5 w-1.5 rounded-full bg-brique" data-id="element-93" data-mp="2c8jo6jrytta6" />
              </span>
              <h3 className="font-display text-xl" data-id="element-94" data-mp="1yamt5rt5tuxm">{step.title}</h3>
              <p className="mt-2 max-w-lg text-base leading-relaxed text-sand-300" data-id="element-95" data-mp="238wpi5qmf1kt">{step.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}